module.exports = __webpack_public_path__ + "img/supply.1587ddb6.jpg";